import React, { useState } from "react";
import Checkbox from "../../../generic/checkbox";
import { FileUpload } from "./fileUpload";
import { OtpSection } from "../../generic/otpSection";
import {createSegmentActivationSR, GetBrokerageSlabDetails, GetSegActivationValidation } from "../../../service/serviceRequest/srApiService";
import { config } from "../../../../config/domain";
import { asyncGetPersonalDetails } from "../../../service/postLogin/clientProfileAPIService";
import { validationMsg, segmentActivationMsg, segmentNamesSMS} from "./constant";
import { PageLoader } from "../../../generic/loader";
import LoginService from "../../../service/login/loginService";
import TocDropdown from "../../../generic/tocDropdown";
import { IListObj } from "../../../types/genericTypes";
import Tooltip from "../../../toc/orderBook/generic/obTooltips";

interface ICommodityTypes{
  BaseMetals: IcomTypeSub;
  Bullion: IcomTypeSub;
  Energy: IcomTypeSub;
  AgriCommodities: IcomTypeSub;
}
interface IcomTypeSub{
  selected: boolean;
  clientTyp: string;
  name: string;
}
export const SegmentActivation = (props: any) => {
  const [segmentActivation, setSegmentActivation] = useState({
    activeSegments: {} as any,
    selectSeg: { NSEFO: false, BSEFO: false, NSECDS: false, BSECDS: false, MSEICDS: false, SLBM: false } as any,
    isNewSegSelected: false,
  });
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [loader, setLoader] = useState<boolean>(false);
  const [slabDetails, setSlabDetails] = useState<any>([]);
  const [clientCategory, setClientCategory] = useState<Array<IListObj>>([]);
  const [comTypes, setComTypes] = useState<any>([]);
  const [accSegDetails, setAccSegDetails] = useState<any>({});
  const [disableSubmit, setDisableSubmit] = useState<boolean>(false);
  const [otpVerified, setOtpVerified] = useState<boolean>(false);
  const [showCommSection, setShowCommSection] = useState<boolean>(false); 
  const [otpSection, setOtpSection] = useState<boolean>(false);
  const [fileUpload, setFileUpload] = useState<boolean>(false);
  const [uploadDet, setUploadDet] = useState<null | any>({});
  const [showSteps, setShowSteps] = useState<boolean>(false);
  const [validationErr, setValidationErr] = useState<any>();
  const [comSegments, setComSegments] = useState<ICommodityTypes>({
    BaseMetals: {selected: true, clientTyp: 'Others', name:"Base Metals"},
    Bullion: {selected: true, clientTyp: 'Others', name:"Bullion"},
    Energy: {selected: true, clientTyp: 'Others', name:"Energy"},
    AgriCommodities: {selected: true, clientTyp: 'Others', name:"Agri-Commodities"}
  })
  const [tcnAcceptval, setTcnAcceptval] = useState({checkbox1: true, checkbox2: true, checkbox3: true});
  
  React.useEffect(() => {
    getSegmentValidationDetails();
    return () => {};
  }, []);
  
  const isImpersonated = () => {
    return window.localStorage.getItem("isImpersonated"); 
  };
  const proceedNext = async () => {
    if((accSegDetails.dpHolding < 5000) && getSegNames() != "SLBM" && !fileUpload && (typeof uploadDet === "object" && Object.keys(uploadDet).length == 0))
      setFileUpload(true);
    else if(((accSegDetails.dpHolding < 5000) && getSegNames() != "SLBM" && fileUpload && uploadDet && !otpSection) || (((accSegDetails.dpHolding > 5000) || (accSegDetails.dpHolding == 5000) || getSegNames() == "SLBM") && !otpSection)){
      setOtpSection(true);
    } else if(otpVerified && otpSection && !showCommSection){
      if((segmentActivation.selectSeg.COMMCX && segmentActivation.activeSegments.COMMCX !== "Y") ||
      (segmentActivation.selectSeg.COMNCDEX && segmentActivation.activeSegments.COMNCDEX !== "Y")){
        setShowCommSection(true);
      } else {
        SubmitSR();
      }
    } else if(showCommSection)
      SubmitSR();
  }
  const SubmitSR =async () => {
    setDisableSubmit(true);
    setLoader(true);
    var selectedSegments = Object.keys(segmentActivation.selectSeg),
      seg_slab : any = [],
      slabDet = slabDetails;
    for (var i = 0; i < selectedSegments.length; i++) {
      if ( segmentActivation.selectSeg[selectedSegments[i]] && segmentActivation.activeSegments[selectedSegments[i]] !== "Y" ) {
        //only for selected segments match the slab names in{segment:slab} format to send in request
        for (var j = 0; j < slabDet.length; j++) {
          if ( selectedSegments[i].indexOf(slabDet[j].segement.segementName) >= 0 ) {
            if (selectedSegments[i] === "SLBM") {
              seg_slab.push({key: "NSESLBM", value: slabDet[j].segement.slabName});
            } else {
              seg_slab.push({key: selectedSegments[i], value: slabDet[j].segement.slabName});
            }
          }
        }
      }
    }
    if((segmentActivation.selectSeg.COMMCX && segmentActivation.activeSegments.COMMCX !== "Y") ||
      (segmentActivation.selectSeg.COMNCDEX && segmentActivation.activeSegments.COMNCDEX !== "Y")){
      var comSegs = Object.keys(comSegments);
      var segmentcommodities: any = [];
      for (var i = 0; i < comSegs.length; i++) {
        if(comSegments[comSegs[i] as keyof typeof comSegments].selected === true){
          var allComTypes = comTypes.filter( 
            (comTyp: any) => {
              return comTyp.category == comSegments[comSegs[i] as keyof typeof comSegments].name;
            }
          )
          var allComTyps= allComTypes.map((v: any) => ({...v, category:comSegments[comSegs[i] as keyof typeof comSegments].clientTyp}))
          segmentcommodities.push(...allComTyps);
                    
        }
      }
    }
    let reqObj = {
      accType: LoginService.getAccData("accTyp"),
      requestType: "Segment Activation",
      dpID: "None",
      demat_holding: accSegDetails.dpHolding ? accSegDetails.dpHolding.toString() : 0,
      client_type: accSegDetails.ClientType,
      income_proof: uploadDet.selectedSegincomeProof ? uploadDet.selectedSegincomeProof : "",
      segment_name: seg_slab,
      segmentcommodities: segmentcommodities ? segmentcommodities : "",
      file_name: uploadDet.segDocFile ? [uploadDet.segDocFile] : [],
      base64_data: uploadDet.base64Data ? [uploadDet.base64Data.replace("data:application/pdf;base64,", "")] : [],
    };
    let createSRRes = await createSegmentActivationSR(reqObj);
    
    setDisableSubmit(false);
    if (createSRRes && createSRRes.hasOwnProperty("data") && createSRRes.data.hasOwnProperty("id")) {
      props.setParLoader(false);
      setLoader(false);
      const value = JSON.parse(createSRRes.data.id);
      if (value) {
          openSRSuccessPopup();
      } else {
          props.setParLoader(false);
          openSRErrorPopup();
      }
    } else if(Object.keys(createSRRes).length > 0 && createSRRes.hasOwnProperty("error") && createSRRes.error.errCd === "SR0005") {
        setLoader(false);
        openExistSrPopup();
    } else {
        if (createSRRes && createSRRes.error) {
            props.setParLoader(false);
            setLoader(false);
            openSRErrorPopup();
        }
    }
  }
   const getCommodities = (type: string) =>{
    var commodities = comTypes.filter( 
      (comTyp: any) => {
        return comTyp.category == type;
      }
    )
    var tooltipList: any = [];
    for (var i = 0; i < commodities.length; i++) {
      tooltipList.push(commodities[i].commodity); 
    }
    return tooltipList;
   }
  const openSRSuccessPopup = () => {
    props.setParLoader(false);
    let paramObj: any = {
        popUp2: true,
        popupType: "Success",
        type: "Segment Activation",
        iconName: "edel-icon-processing",
        content: segmentActivationMsg.createSR.content,
        contentBold: getSegNames(),
        redirectionLink: segmentActivationMsg.createSR.redirectionLink,
        redirectionText: segmentActivationMsg.createSR.redirectionText
    };
    props.onSubmit("segmentActivation", paramObj);
  };
  const openExistSrPopup = () => {
    props.setLoader(false);
    props.onSubmit("segmentActivation", {
      headerText: "You have an active service request",
      content: "You already have an active service request. Once it is updated, you will be able to raise new request.",
    });
  };
  const openSRErrorPopup = (mess?: string) => {
    props.setParLoader(false);
    props.onSubmit("segmentActivation", {
      headerText: mess ? mess : segmentActivationMsg.error,
    });
  }
  const getSegNames = () => {
    var segNames = Object.keys(segmentActivation.activeSegments);   
    var selectedSegNames =""
    for (var i = 0; i < segNames.length; i++) {
      if (segmentActivation.selectSeg[segNames[i]] && segmentActivation.activeSegments[segNames[i]] !== "Y" && segNames[i]!= "COMMCX") {
            selectedSegNames = selectedSegNames + segmentNamesSMS[segNames[i] as keyof typeof segmentNamesSMS] + ", ";
        }
    }
    selectedSegNames= selectedSegNames.slice(0, -2);
    let newSegnames = selectedSegNames.split(",")
    let tempArr : any = [];
    newSegnames.forEach((ele) => {
        if(!tempArr.includes(ele.trim())) {
         tempArr.push(ele.trim())
        }
    })
    let finalSegnames = tempArr.join(",")
    return finalSegnames;
    //return selectedSegNames;
  };
  const allSegEnabled = () => {
    var segNames = Object.keys(segmentActivation.activeSegments);
    var notActivated = segNames.filter((ele: any) => {
        return (
          segmentActivation.activeSegments[ele] == "N"
        )
    });
    if(notActivated){
        return false;
    }
    return true;
}
  const checkSegmentEnabled = () => {
    var selectedSegments = Object.keys(segmentActivation.selectSeg); 
    for (var i = 0; i < selectedSegments.length; i++) {
      if (segmentActivation.selectSeg[selectedSegments[i]] && segmentActivation.activeSegments[selectedSegments[i]] !== "Y") {
        return true;
      }
    }
    return false;
  };   
  const getBrokerageSlabDetails = async (segList: string | any[]) => {
    const res = await GetBrokerageSlabDetails({
      accType:"COMEQ",
      segments: ["FO","CDS","SLBM","COMNCDEX","COMMCX"]
    });
    if(res.data?.segmentsList){
      var slabdata = res.data.segmentsList;
      for (var i = 0; i < segList.length; i++) {
        if (segList[i].status === "Y" && segList[i].exist_segment_slab && segList[i].exist_segment_slab !== "") {
            for (var j = 0; j < slabdata.length; j++) {
                if (segList[i].segementName.indexOf(slabdata[j].segement.segementName) >= 0) {
                    slabdata[j].segement.slabName = segList[i].exist_segment_slab;
                }
            }
        }
    }
      setSlabDetails(slabdata);
    } else {
      openSRErrorPopup();
    };    
    props.setLoader(false);
    setLoader(false);
    setDisableSubmit(false);
    const profile = await asyncGetPersonalDetails();
    setMobile(profile.mobileNumberField);
    setEmail(profile.emailAddressField);
  };

  const getSegmentValidationDetails = async () => {
    props.setLoader(true);
    setLoader(true);
    setDisableSubmit(true);
    try {
      const validateDetSegRes = await GetSegActivationValidation();
      if (validateDetSegRes && validateDetSegRes.data && validateDetSegRes.data.hasOwnProperty("value")){
        const value = JSON.parse(validateDetSegRes.data.value);
        if (value && value.length > 0) {
          setAccSegDetails({
            dpHolding: value[0].dpHolding,
            kraStatus: value[0].KRAStatus,
            nameMatch: value[0].Name_Match,
            dormant: value[0].Dormant,
            ClientType: value[0].ClientType,
            eblpoa: value[0].EBLPOA,
            eqSeg: value[0].EQSeg
          });
          if(value[0].Category){
            var clientTypes: any = [{}];
            for (var i = 0; i < value[0].Category.length; i++) {
              clientTypes.push({
                value: value[0].Category[i],
                display: value[0].Category[i]
              })
            }
            setClientCategory(clientTypes)
          }
            
          var comTypes: any = [];
          if(value[0].MCX){
            var mcxLst = value[0].MCX;
            for (var i = 0; i < mcxLst.length; i++) {
              var temp = mcxLst[i].split(',');
              comTypes.push({
                'commodity': temp[0],
                'category': temp[1],
                'exchange': "COM MCX"
              });
            }
          }
          if(value[0].NCDEX){
            var ncdexLst = value[0].NCDEX;
            for(var i = 0; i < ncdexLst.length; i++){
              var temp = ncdexLst[i].split(',');
              comTypes.push({
                'commodity': temp[0],
                'category': temp[1],
                'exchange': "COM NCDEX"
              });
            }
          }
          setComTypes([...comTypes]);
          var segmentList = value[0].lst;
          var activeSegments: any = {};
          var selectSeg: any = {};
          for (var i = 0; i < segmentList.length; i++) {
            var segName = segmentList[i].segementName.replace("_", "")
            activeSegments[segName] = segmentList[i].status;
            //if already segment is active for the user, enable by them by default
            if (segmentList[i].status === "Y") {
              selectSeg[segName] = true;
            }
          }
          if(value[0].validationStatus && value[0].validationStatus == "failed"){
            setDisableSubmit(true);
            const validationRemarks = value[0].validationRemark;
            if ( validationRemarks && validationRemarks.length > 0) {
              let err: any = {};
              validationRemarks.map((x: any) => {
                err[`${x.validation_key}`] = validationMsg[x.validation_key as keyof typeof validationMsg].err;
              });
              setValidationErr(err);
            }
          }
          setSegmentActivation({
            ...segmentActivation,
            activeSegments,
            selectSeg,
          });
        }
      }
      getBrokerageSlabDetails(segmentList);
    } catch (error) {
      props.setLoader(false);
      setLoader(false);
    }
  };
  
  return (
    <>
    <div className="segmentDeactivate">
      <div className="container">
        {loader && (
            <div style={{ textAlign: "center", position: "fixed", top:"44%", left:"50%", margin:"0 0 0 -62px"}}>
              <PageLoader size={50}></PageLoader>
            </div>
        )}  
        {!loader && !fileUpload && !otpSection && !showCommSection && (
          <div className="segment-body">
            <div className="steps-block"><span className="inactive">Step 1</span></div>
            <h3 className="main-heading">Select Segments to Activate</h3>
            <div className="segment-container">
              { (segmentActivation.activeSegments["NSEFO"] || segmentActivation.activeSegments["BSEFO"]) && (
              <div className="segment-box">
                  <div className={
                    accSegDetails?.acStatus === "N" ||
                    (segmentActivation?.activeSegments && (segmentActivation.activeSegments["NSEFO"] === "Y" && segmentActivation.activeSegments["BSEFO"] === "Y"))                           
                      ? "segment-checkbox grey-checkbox "
                      : "segment-checkbox"
                  }>
                  <Checkbox
                      onChange={(event) => {
                          setSegmentActivation({
                              ...segmentActivation,
                              selectSeg : {...segmentActivation.selectSeg, NSEFO: event.target.checked, BSEFO: event.target.checked}
                      });
                      }}
                      checked={segmentActivation.selectSeg["NSEFO"] && segmentActivation.selectSeg["BSEFO"]}
                      name=""
                      disabled={
                        accSegDetails.acStatus === "N" || 
                        (segmentActivation.activeSegments["NSEFO"] === "Y" &&
                        segmentActivation.activeSegments["BSEFO"] === "Y")
                      }
                  />
                  </div>
                  <div className="segment-info">
                      <label className="segment-name">Equity Derivatives</label>
                      <label className="segment-exc">{(segmentActivation.activeSegments["NSEFO"] === "N" && segmentActivation.activeSegments["BSEFO"] === "N") ||  (segmentActivation.activeSegments["NSEFO"] === "Y" && segmentActivation.activeSegments["BSEFO"] === "Y")? "NSE, BSE" : (segmentActivation.activeSegments["NSEFO"] === "Y" && segmentActivation.activeSegments["BSEFO"] === "N") ? "BSE" : "NSE"}</label>
                  </div>
              </div>)}
              { (segmentActivation.activeSegments["NSECDS"] || segmentActivation.activeSegments["BSECDS"]) && (
              <div className="segment-box">
                  <div className={
                    accSegDetails?.acStatus === "N" ||
                    (segmentActivation?.activeSegments && (segmentActivation.activeSegments["NSECDS"] === "Y" && segmentActivation.activeSegments["BSECDS"] === "Y"))                           
                      ? "segment-checkbox grey-checkbox "
                      : "segment-checkbox"
                  }>
                  <Checkbox
                      onChange={(event) => {
                          setSegmentActivation({
                              ...segmentActivation,
                              selectSeg : {...segmentActivation.selectSeg, NSECDS: event.target.checked, BSECDS: event.target.checked}
                          });
                      }}
                      checked={segmentActivation.selectSeg.NSECDS && segmentActivation.selectSeg.BSECDS}
                      name=""
                      disabled={
                        accSegDetails.acStatus === "N" || 
                        (segmentActivation.activeSegments["NSECDS"] === "Y" &&
                        segmentActivation.activeSegments["BSECDS"] === "Y")
                      }
                  />
                  </div>
                  <div className="segment-info">
                      <label className="segment-name">Currency Derivatives</label>
                      <label className="segment-exc">{(segmentActivation.activeSegments["NSECDS"] === "N" && segmentActivation.activeSegments["BSECDS"] === "N") ||  (segmentActivation.activeSegments["NSECDS"] === "Y" && segmentActivation.activeSegments["BSECDS"] === "Y")? "NSE, BSE" : (segmentActivation.activeSegments["NSECDS"] === "Y" && segmentActivation.activeSegments["BSECDS"] === "N") ? "BSE" : "NSE"}</label>
                  </div>
              </div>)}
              { segmentActivation.activeSegments["SLBM"] && (
              <div className="segment-box">
                  <div className={
                    accSegDetails?.acStatus === "N" ||
                    (segmentActivation?.activeSegments && segmentActivation.activeSegments["SLBM"] === "Y")                           
                      ? "segment-checkbox grey-checkbox "
                      : "segment-checkbox"
                  }>
                  <Checkbox
                      onChange={(event) => {
                      setSegmentActivation({
                              ...segmentActivation,
                              selectSeg : {...segmentActivation.selectSeg , SLBM: event.target.checked}
                          });
                      }}
                      checked={segmentActivation.selectSeg.SLBM}
                      name=""
                      disabled={ accSegDetails.ClientType === "PUREONLINE" ||
                        accSegDetails.acStatus === "N" || segmentActivation.activeSegments["SLBM"] === "Y"
                      }
                  />
                  </div>
                  <div className="segment-info">
                      <label className="segment-name">SLBM</label>
                      <label className="segment-exc">NSE</label>
                  </div>
              </div>)}
              { (segmentActivation.activeSegments["COMMCX"] || segmentActivation.activeSegments["COMNCDEX"]) && (
              <div className="segment-box">
                  <div className={
                    accSegDetails?.acStatus === "N" ||
                    (segmentActivation?.activeSegments && (segmentActivation.activeSegments["COMMCX"] === "Y" && segmentActivation.activeSegments["COMNCDEX"] === "Y"))                           
                      ? "segment-checkbox grey-checkbox "
                      : "segment-checkbox"
                  }>
                  <Checkbox
                      onChange={(event) => {
                          setSegmentActivation({
                              ...segmentActivation,
                              selectSeg : {...segmentActivation.selectSeg, COMMCX: event.target.checked, COMNCDEX: event.target.checked}
                      });
                      }}
                      checked={segmentActivation.selectSeg.COMMCX && segmentActivation.selectSeg.COMNCDEX}
                      name=""
                      disabled={
                        accSegDetails.acStatus === "N" || 
                        (segmentActivation.activeSegments["COMMCX"] === "Y" &&
                        segmentActivation.activeSegments["COMNCDEX"] === "Y")
                      }
                  />
                  </div>
                  <div className="segment-info">
                      <label className="segment-name">Commodity Derivatives</label>
                      <label className="segment-exc">{(segmentActivation.activeSegments["COMMCX"] === "N" && segmentActivation.activeSegments["COMNCDEX"] === "N") ||  (segmentActivation.activeSegments["COMMCX"] === "Y" && segmentActivation.activeSegments["COMNCDEX"] === "Y")? "MCX, NCDEX" : (segmentActivation.activeSegments["COMMCX"] === "Y" && segmentActivation.activeSegments["COMNCDEX"] === "N") ? "MCX" : "NCDEX"}</label>
                  </div>
              </div>)}
              {(segmentActivation.selectSeg.NSEFO || segmentActivation.selectSeg.BSEFO || segmentActivation.selectSeg.NSECDS || segmentActivation.selectSeg.BSECDS || segmentActivation.selectSeg.SLBM || segmentActivation.selectSeg.COMNCDEX || segmentActivation.selectSeg.COMMCX) && (
              <>
              <div className="text-lefti">
                {(accSegDetails.dpHolding < 5000) && checkSegmentEnabled() && (
                  <p className="note-text"><b>Please Note:</b> Investing in derivatives requires you to submit income proof.</p>
                )}
                {/* terms and conditions for SLBM*/}
                {segmentActivation.selectSeg.SLBM && segmentActivation.activeSegments["SLBM"] === "N" && (
                  <>
                    <div className="display-flex declarationWrap mg-t5">
                      <Checkbox
                        onChange={() => { setTcnAcceptval({ ...tcnAcceptval, checkbox1: !tcnAcceptval.checkbox1 }); }}
                        checked={tcnAcceptval.checkbox1}
                        name=""
                        disabled={otpSection || otpVerified}
                      />
                      <span className="incomeMsg regular-font declare text-lefti pd-l10">
                        I/We confirm that I am/we are aware of document related to rights and obligations of clearing member/participant and its client in relation to the Securities Lending and Borrowing Scheme (SLBS).
                      </span>
                    </div>
                    <div className="display-flex declarationWrap mg-t5">
                      <Checkbox
                        onChange={() => { setTcnAcceptval({ ...tcnAcceptval, checkbox2: !tcnAcceptval.checkbox2 }); }}
                        checked={tcnAcceptval.checkbox2}
                        name=""
                        disabled={otpSection || otpVerified}
                      />
                      <span className="incomeMsg regular-font declare text-lefti pd-l10">
                        {" "} I/We confirm that all the transactions under the SLBS by the Client have to be strictly in accordance with SEBI Scheme, Circulars of SEBI, SLBS and the Circulars issued there under and the Rules, Byelaws, Regulations of the Clearing Corporation as applicable and the terms and conditions of the said Agreement.{" "}
                      </span>
                    </div>
                    <div className="display-flex declarationWrap mg-t5">
                      <Checkbox
                        onChange={() => { setTcnAcceptval({ ...tcnAcceptval, checkbox3: !tcnAcceptval.checkbox3 });}}
                        checked={tcnAcceptval.checkbox3}
                        name=""
                        disabled={otpSection || otpVerified}
                      />
                      <span className="incomeMsg regular-font declare text-lefti pd-l10">
                        {" "} I/We further confirm that I/we have read and understood the contents of the
                        <a target="_blank" className="blue-link-text" href="https://www.nuvamawealth.com/ewwebimages/WebFiles/SR_PDF/SLBM_TnC.pdf">
                          'Rights and Obligations' document(s). {" "}
                        </a>
                        {" "} I/We do hereby agree to be bound by such provisions as outlined in these documents.{" "}
                      </span>
                    </div>
                  </>
                )}
                {checkSegmentEnabled() && (
                <div className="table-responsive">
                  <h4>Brokerage Details</h4>
                  <table className="slab-details">
                    {checkSegmentEnabled() && (
                      <thead className="table-head">
                        <th><p></p></th>
                        <th><p>Future</p></th>
                        <th><p>Options</p></th>
                      </thead>
                    )}
                    <tbody>
                      {slabDetails.length > 0 &&
                        slabDetails.map((ele: any) => {
                          if (
                            ele.segement.segementName === "FO" &&
                            ((segmentActivation.selectSeg.NSEFO && segmentActivation.activeSegments.NSEFO !== "Y") ||
                              (segmentActivation.selectSeg.BSEFO && segmentActivation.activeSegments.BSEFO !== "Y"))
                          )
                            return (
                              <tr>
                                <th><p>Equity Derivatives</p></th>
                                <td><p>{ele.segement.future}</p></td>
                                <td><p>{ele.segement.options}</p></td>
                              </tr>
                            );
                          if (
                            ele.segement.segementName === "CDS" &&
                            ((segmentActivation.selectSeg.NSECDS && segmentActivation.activeSegments.NSECDS !== "Y") ||
                              (segmentActivation.selectSeg.MSEICDS && segmentActivation.activeSegments.MSEICDS !== "Y") ||
                              (segmentActivation.selectSeg.BSECDS && segmentActivation.activeSegments.BSECDS !== "Y") )
                          )
                            return (
                              <tr>
                                <th><p>Currency Derivatives</p></th>
                                <td><p>{ele.segement.future}</p></td>
                                <td><p>{ele.segement.options}</p></td>
                              </tr>
                            );
                          if (
                            ele.segement.segementName === "SLBM" &&
                            segmentActivation.selectSeg.SLBM && segmentActivation.activeSegments.SLBM !== "Y"
                          )
                            return (
                              <tr>
                                <th><p> SLBM </p></th>
                                <td><p>{ele.segement.future}</p></td>
                                <td><p>{ele.segement.options}</p></td>
                              </tr>
                            );
                          if (
                            ele.segement.segementName === "COMNCDEX" &&
                            ((segmentActivation.selectSeg.COMNCDEX && segmentActivation.activeSegments.COMNCDEX !== "Y") ||
                            (segmentActivation.selectSeg.COMMCX && segmentActivation.activeSegments.COMMCX !== "Y"))
                          )
                            return (
                              <tr>
                                <th><p>Commodity Derivatives</p></th>
                                <td><p>{ele.segement.future}</p></td>
                                <td><p>{ele.segement.options}</p></td>
                              </tr>
                            );
                        })}
                    </tbody>
                  </table>
                </div>)}
                {checkSegmentEnabled() && (
                  <>
                  <p className="note-text mg-t10">
                    If you want customized brokerage rates for selected segments, kindly{" "}
                    <a href={config.rootUrl + "clientarea"} className="blue-link-text bold-text" > Contact your RM </a>
                  </p>
                  </>
                )}
                {allSegEnabled() && (
                  <>
                  <br/><p className="text">All segments are activated hence request cannot be submitted </p><br/>
                  </>
                )}
              </div>
              </>
              )}
            </div>
            <div className="segment-error-container">
            {typeof validationErr === "object" && Object.keys(validationErr).length > 0 && (
              Object.keys(validationErr).map(
                (val: any) => {
                  return (
                    <div className="segment-error-box mg-b10">
                      <i className="edel-icon-tooltip"></i>
                      <span className="error-msg">
                          {validationErr[val]}
                      </span>
                    </div>
                  );
                }
              )
            )}
            </div>
          </div>
        )}
        {!loader && fileUpload && !otpSection && (
          <div className="segment-body">
            <div className="steps-block"><span className="inactive">Step 2</span></div>
            <h3 className="main-heading pd-t5 pd-b0">Upload Documents</h3>
            <p className="note-text pd-b20">Investing in derivatives requires you to submit income proof.</p>
            <div className="sub-heading">Income proof</div>
            <FileUpload
              onSubmit={(val: any) => setUploadDet(val)}
              segDetails={{
                disableEdit: false,
                showDropdown: accSegDetails.dpHolding < 5000 &&
                  ( segmentActivation.selectSeg.NSEFO || segmentActivation.selectSeg.COMMCX || segmentActivation.selectSeg.BSEFO ||
                    segmentActivation.selectSeg.NSECDS || segmentActivation.selectSeg.COMNCDEX || segmentActivation.selectSeg.BSECDS ),
                showDragUploadSec: !accSegDetails.dpHolding && (segmentActivation.selectSeg.NSEFO || segmentActivation.selectSeg.NSECDS)
              }}
            />
          </div>
        )}
        {!loader && otpSection && !showCommSection && (
          <div className="segment-body">
            <div className="steps-block"><span className="inactive">{(accSegDetails.dpHolding < 5000 && getSegNames() != "SLBM") ? 'Step 3' : 'Step 2'}</span></div>
            <h3 className="main-heading">Authenticate using OTP</h3>
            <div className="segment-otpSection">
              <OtpSection
                details={{
                  acTyp: LoginService.getAccData("accTyp"),
                  reqTyp: "generate",
                  srType: "Segment Activation",
                  srAcType: "none",
                  dpId:"none",
                  type: "mobile_and_email",
                  userType : isImpersonated() ? "RM" : "Client",
                  mobileNo: mobile,
                  emailId: email,
                  segmentType: getSegNames()
                }}
                otpVerified={(token: any) => {
                  setOtpVerified(true);
                }}
                setParLoader={(val: boolean) => {
                  props.setParLoader(val);
                }}
                showVerify= {!otpVerified}
                containerClass="segment-otp-box"
                otpHeader="otp-header"
                inputClass="text-field"
              />
            </div>
          </div>
        )}
        {!loader && showCommSection && (
          <div className="segment-body">
            <div className="steps-block"><span className="inactive">{(accSegDetails.dpHolding < 5000 && getSegNames() != "SLBM") ? 'Step 4' : 'Step 3'}</span></div>
            <h3 className="main-heading pd-t5 pd-b0">Select Commodities</h3>
            <p className="note-text pd-b20">Please select appropriate category depending upon proposed nature of your activity against each product type.</p>
            <div className="segment-container">
              <div className="table-responsive">
              <table className="commtype-table">
                <thead>
                  <th><p>Commodity Type</p></th>
                  <th><p>Client Type</p></th>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <div className="display-flex pd-r10 pd-l10">
                      <Checkbox
                        name=""
                        disabled={false}
                        checked={comSegments.Bullion.selected}
                        onChange={(event) => {
                          setComSegments({
                            ...comSegments,
                            Bullion:{...comSegments.Bullion, selected: event.target.checked}   
                          });
                        }}
                      />
                      <span className="pd-l10">Bullion</span><Tooltip tooltipList={getCommodities("Bullion")} />
                      </div>
                      
                    </td>
                    <td className="pd-all0">
                      <TocDropdown
                        selectedValue={comSegments.Bullion.clientTyp}
                        dropdownOptions={clientCategory.filter((ele:IListObj) => {
                          return ele.display !== "Farmer Producer Organization/ Farmer";
                        })}
                        onSelect={(val: any) => {
                          let value = clientCategory.filter((ele: { value: any; }) => {
                            if (ele.value === val) return ele;
                          });
                          setComSegments({
                            ...comSegments,
                            Bullion:{...comSegments.Bullion, clientTyp: value[0].value as string}   
                          });
                        }}
                        disabled={false}
                        isSearchable={false}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className="display-flex pd-r10 pd-l10">
                      <Checkbox
                        name=""
                        disabled={false}
                        checked={comSegments.BaseMetals.selected}
                        onChange={(event) => {
                          setComSegments({
                            ...comSegments,
                            BaseMetals:{...comSegments.BaseMetals, selected: event.target.checked}   
                        });
                        }}
                      />
                      <span className="pd-l10">Base Metals</span><Tooltip tooltipList={getCommodities("Base Metals")} />
                      </div>
                    </td>
                    <td className="pd-all0">
                      <TocDropdown
                        selectedValue={comSegments.BaseMetals.clientTyp}
                        dropdownOptions={clientCategory.filter((ele:IListObj) => {
                          return ele.display != "Farmer Producer Organization/ Farmer";
                        })}
                        onSelect={(val: any) => {
                          let value = clientCategory.filter((ele: { value: any; }) => {
                            if (ele.value === val) return ele;
                          });
                          setComSegments({
                            ...comSegments,
                            BaseMetals:{...comSegments.BaseMetals, clientTyp: value[0].value as string}   
                          });
                        }}
                        disabled={false}
                        isSearchable={false}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                    <div className="display-flex pd-r10 pd-l10">
                      <Checkbox
                        name=""
                        disabled={false}
                        checked={comSegments.Energy.selected}
                        onChange={(event) => {
                          setComSegments({
                            ...comSegments,
                            Energy:{...comSegments.Energy, selected: event.target.checked}   
                        });
                        }}
                      />
                      <span className="pd-l10">Energy</span><Tooltip tooltipList={getCommodities("Energy")} />
                      </div>
                    </td>
                    <td className="pd-all0">
                      <TocDropdown
                        selectedValue={comSegments.Energy.clientTyp}
                        dropdownOptions={clientCategory.filter((ele:IListObj) => {
                          return ele.display != "Farmer Producer Organization/ Farmer";
                        })}
                        onSelect={(val: any) => {
                          let value = clientCategory.filter((ele: { value: any; }) => {
                            if (ele.value === val) return ele;
                          });
                          setComSegments({
                            ...comSegments,
                            Energy:{...comSegments.Energy, clientTyp: value[0].value as string}   
                          });
                        }}
                        disabled={false}
                        isSearchable={false}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                    <div className="display-flex pd-l10">
                      <Checkbox
                        name=""
                        disabled={true}
                        checked={comSegments.AgriCommodities.selected}
                        onChange={(event) => {
                          setComSegments({
                            ...comSegments,
                            AgriCommodities:{...comSegments.AgriCommodities, selected: event.target.checked}   
                        });
                        }}
                      />
                      <span className="pd-l10">Agri-Commodities</span><Tooltip tooltipList={getCommodities("Agri-Commodities")} />
                      </div>
                    </td>
                    <td className="pd-all0">
                      <TocDropdown
                        selectedValue={comSegments.AgriCommodities.clientTyp}
                        dropdownOptions={clientCategory}
                        onSelect={(val: any) => {
                          let value = clientCategory.filter((ele: { value: any; }) => {
                            if (ele.value === val) return ele;
                          });
                          setComSegments({
                            ...comSegments,
                            AgriCommodities:{...comSegments.AgriCommodities, clientTyp: value[0].value as string}   
                          });
                        }}
                        disabled={false}
                        isSearchable={false}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
              </div>
              <div className="note-section">
                <p className="note-head"><b>Note</b></p>
                <p>By default, your client type is selected as Others for all the commodity type categories. If you wish to edit, kindly select the trading preference against each commodity type you wish to trade in. For more information on commodity wise categorization, 
                  <br/><a onClick={()=>{setShowSteps(!showSteps)}}>please click here </a>{showSteps && <i className="edel-icon-arrow-down"/>}
                </p>
                {showSteps && (<>
                  <p>i. Farmers/FPOs: It includes participants such as farmers, farmers’ co-operatives, Famers Producers Organisations (FPOs) and such entities of like nature.</p>
                  <p>ii. Value chain participants (VCPs): It includes participants such as Processors, Commercial users as Dal and Flour Millers, Importers, Exporters, Physical Market Traders, Stockists, Cash & Carry participants, Produces, SMEs/MSMEs & Wholesalers etc., but exclude farmers/FPOs.</p>
                  <p>iii. Proprietary traders: It includes the members of stock exchanges trading in their proprietary account.</p>
                  <p>iv. Domestic financial institutional investors: It includes participants such as Mutual Funds (MFs), Portfolio Managers, Alternative Investment Funds (AIFs), Banks, Insurance Companies and Pension Funds etc., which are allowed to trade in commodity derivatives.</p>
                  <p>v. Foreign participants: It includes participants such as Eligible Foreign Entities (EFEs), NRIs etc. which are allowed to trade in commodity derivatives markets.</p>
                  <p>vi. Others: All other participants which cannot be classified in the above categories.</p>
                </>
                )}
              </div>
            </div>
          </div>
        )}
        <div className="segment-footer mg-t20">
          <button type="submit" className="btn btn-blue login-btn"
            onClick={(e: any) => { proceedNext(); e.preventDefault();}}
            disabled = {
              (typeof validationErr === "object" && Object.keys(validationErr).length > 0) || !checkSegmentEnabled() || 
              ((!tcnAcceptval.checkbox1 || !tcnAcceptval.checkbox2 || !tcnAcceptval.checkbox3) && segmentActivation.selectSeg.SLBM && segmentActivation.activeSegments["SLBM"] === "N") ||
              disableSubmit || (otpSection && !otpVerified) || (fileUpload && (typeof uploadDet === "object" && Object.keys(uploadDet).length == 0)) || 
              (showCommSection && !comSegments.Energy.selected && !comSegments.Bullion.selected && !comSegments.BaseMetals.selected)
            }
          >
            Proceed
          </button>
          <button type="submit" className="btn btn-olink login-btn" disabled= {disableSubmit}>
            <a className="btn btn-olink login-btn" href={window.location.href.includes("ajs") ? config.rootUrl+"clientarea/servicerequest" : config.root+"/clientarea/service-request"}>
              Cancel
            </a>
          </button>
        </div>
      </div>
    </div>
    </>
  );
};
